// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GlassesDemo_debugDashboard__8IcPh {
  position: fixed;
  top: 20px;
  right: 20px;
  color: #00ff00;
  padding: 15px;
  border-radius: 8px;
  font-family: monospace;
  z-index: 1000;
  min-width: 250px;
  box-shadow: 0 0 10px rgba(0, 255, 0, 0.2);
  border: 1px solid #00ff00;
  display: none;
}

.GlassesDemo_debugDashboard__8IcPh h3 {
  margin: 0 0 10px 0;
  color: #00ff00;
  font-size: 16px;
  border-bottom: 1px solid #00ff00;
  padding-bottom: 5px;
}

.GlassesDemo_debugDashboard__8IcPh table {
  width: 100%;
  border-collapse: collapse;
}

.GlassesDemo_debugDashboard__8IcPh td {
  padding: 4px 0;
  font-size: 14px;
}

.GlassesDemo_debugDashboard__8IcPh td:first-child {
  color: #88ff88;
  padding-right: 10px;
}

.GlassesDemo_SceneContainer__gLftA {
  position: relative;
  min-height: 1600vh;
  padding-top: 100px;
  padding-bottom: 100px;
  width: 100%;
  overflow: hidden;
}

.GlassesDemo_viewerContainer__7F2dm {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  z-index: 1;
  opacity: 0;
  transform: translateY(50px);
  transition: opacity 0.5s ease, transform 0.5s ease;
  pointer-events: none;
}

.GlassesDemo_viewerContainer__7F2dm.GlassesDemo_visible__pdOez {
  opacity: 1;
  transform: translateY(0);
}

.GlassesDemo_viewerContainer__7F2dm.GlassesDemo_hide__G5ptE {
  opacity: 0;
  transform: translateY(-50px);
}

.GlassesDemo_contentContainer__8ZYGT {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  pointer-events: none;
  z-index: 200;
}

.GlassesDemo_content__p2Bhl {
  max-width: 1600px;
  margin-top: 20vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.GlassesDemo_section__Zal33 {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.4s ease-out, transform 0.4s ease-out;
  position: absolute;
  margin-left: auto;
  margin-right: auto;
  padding-left: 16px;
  padding-right: 16px;
  width: 60%;
  text-align: center;
  color: white;
}

.GlassesDemo_section__Zal33.GlassesDemo_visible__pdOez {
  opacity: 1;
  transform: translateY(0);
}

.GlassesDemo_title__kxzRP {
  font-size: 3rem;
  font-weight: 600;
  line-height: 1.2;
  padding-left: 20px;
  padding-right: 20px;
}

.GlassesDemo_subtitle__zIp2j {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  padding-left: 20px;
  padding-right: 20px;
  line-height: 1.2;
}

.GlassesDemo_description__5z4RD {
  font-size: 24px;
  line-height: 1.5;
  padding-left: 20px;
  padding-right: 20px;
  color: silver;
}

@media (max-width: 768px) {
  .GlassesDemo_section__Zal33 {
    width: 100%;
  }

  .GlassesDemo_title__kxzRP {
    font-size: 2rem;
  }

  .GlassesDemo_subtitle__zIp2j {
    font-size: 2rem;
  }

  .GlassesDemo_description__5z4RD {
    font-size: 1rem;
  }

  .GlassesDemo_debugDashboard__8IcPh {
    top: 10px;
    right: 10px;
    font-size: 12px;
    min-width: 200px;
    padding: 10px;
  }
} `, "",{"version":3,"sources":["webpack://./src/pages/HomePage/Sections/GlassesDemo/GlassesDemo.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,cAAc;EACd,aAAa;EACb,kBAAkB;EAClB,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,yCAAyC;EACzC,yBAAyB;EACzB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,UAAU;EACV,UAAU;EACV,2BAA2B;EAC3B,kDAAkD;EAClD,oBAAoB;AACtB;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,oBAAoB;EACpB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,2BAA2B;EAC3B,0DAA0D;EAC1D,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE;IACE,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;IACT,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,aAAa;EACf;AACF","sourcesContent":[".debugDashboard {\n  position: fixed;\n  top: 20px;\n  right: 20px;\n  color: #00ff00;\n  padding: 15px;\n  border-radius: 8px;\n  font-family: monospace;\n  z-index: 1000;\n  min-width: 250px;\n  box-shadow: 0 0 10px rgba(0, 255, 0, 0.2);\n  border: 1px solid #00ff00;\n  display: none;\n}\n\n.debugDashboard h3 {\n  margin: 0 0 10px 0;\n  color: #00ff00;\n  font-size: 16px;\n  border-bottom: 1px solid #00ff00;\n  padding-bottom: 5px;\n}\n\n.debugDashboard table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.debugDashboard td {\n  padding: 4px 0;\n  font-size: 14px;\n}\n\n.debugDashboard td:first-child {\n  color: #88ff88;\n  padding-right: 10px;\n}\n\n.SceneContainer {\n  position: relative;\n  min-height: 1600vh;\n  padding-top: 100px;\n  padding-bottom: 100px;\n  width: 100%;\n  overflow: hidden;\n}\n\n.viewerContainer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  z-index: 1;\n  opacity: 0;\n  transform: translateY(50px);\n  transition: opacity 0.5s ease, transform 0.5s ease;\n  pointer-events: none;\n}\n\n.viewerContainer.visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.viewerContainer.hide {\n  opacity: 0;\n  transform: translateY(-50px);\n}\n\n.contentContainer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  pointer-events: none;\n  z-index: 200;\n}\n\n.content {\n  max-width: 1600px;\n  margin-top: 20vh;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.section {\n  opacity: 0;\n  transform: translateY(30px);\n  transition: opacity 0.4s ease-out, transform 0.4s ease-out;\n  position: absolute;\n  margin-left: auto;\n  margin-right: auto;\n  padding-left: 16px;\n  padding-right: 16px;\n  width: 60%;\n  text-align: center;\n  color: white;\n}\n\n.section.visible {\n  opacity: 1;\n  transform: translateY(0);\n}\n\n.title {\n  font-size: 3rem;\n  font-weight: 600;\n  line-height: 1.2;\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.subtitle {\n  font-size: 2.5rem;\n  margin-bottom: 1rem;\n  padding-left: 20px;\n  padding-right: 20px;\n  line-height: 1.2;\n}\n\n.description {\n  font-size: 24px;\n  line-height: 1.5;\n  padding-left: 20px;\n  padding-right: 20px;\n  color: silver;\n}\n\n@media (max-width: 768px) {\n  .section {\n    width: 100%;\n  }\n\n  .title {\n    font-size: 2rem;\n  }\n\n  .subtitle {\n    font-size: 2rem;\n  }\n\n  .description {\n    font-size: 1rem;\n  }\n\n  .debugDashboard {\n    top: 10px;\n    right: 10px;\n    font-size: 12px;\n    min-width: 200px;\n    padding: 10px;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"debugDashboard": `GlassesDemo_debugDashboard__8IcPh`,
	"SceneContainer": `GlassesDemo_SceneContainer__gLftA`,
	"viewerContainer": `GlassesDemo_viewerContainer__7F2dm`,
	"visible": `GlassesDemo_visible__pdOez`,
	"hide": `GlassesDemo_hide__G5ptE`,
	"contentContainer": `GlassesDemo_contentContainer__8ZYGT`,
	"content": `GlassesDemo_content__p2Bhl`,
	"section": `GlassesDemo_section__Zal33`,
	"title": `GlassesDemo_title__kxzRP`,
	"subtitle": `GlassesDemo_subtitle__zIp2j`,
	"description": `GlassesDemo_description__5z4RD`
};
export default ___CSS_LOADER_EXPORT___;
